import { MapReportStatuses } from './Constants'
import IoApi from '@/api/IOApi'
import dayjs from 'dayjs'

export const mapReportFormFactory = async advertiserId => {
  const form = new MapReportForm(advertiserId)
  form.insertionOrderList = await form.findInsertionOrderList(advertiserId)
  return form
}

class MapReportForm {
  constructor(advertiserId = null) {
    this.id = 0
    this.name = ''
    this.status = MapReportStatuses.Waiting
    this.url = null
    this.advertiserId = advertiserId
    this.accountId = 0
    this.advertiserName = null
    this.insertionOrderId = 0
    this.insertionOrderName = null
    this.extractionStartDate = null
    this.extractionEndDate = null
    this.rejectReason = null
    this.createdTime = null
    this.insertionOrderList = []
  }

  setExtractionDefaultDay() {
    this.extractionStartDate = null
    this.extractionEndDate = dayjs()
      .subtract(1, 'd')
      .format('YYYY-MM-DD 23:59:59')
  }

  isCreateValid(isAllPeriod) {
    const isCommonValid = this.name !== '' && this.insertionOrderName !== null
    if (isAllPeriod) return isCommonValid
    return (
      isCommonValid &&
      this.extractionStartDate !== null &&
      this.extractionEndDate !== null
    )
  }

  async findInsertionOrderList(advertiserId) {
    const searchResult = await IoApi.fetchIOList({
      advertiserId,
    })
    return searchResult.items.map(ad => {
      const id = ad.id
      const anIoId = ad.anIoId
      const name = ad.name
      return { id, anIoId, name }
    })
  }
}
